import React, { Component, cloneElement, useState } from 'react';
import { List, CreateButton, Datagrid, downloadCSV, TextField, DateField, SelectInput, EditButton, DeleteButton, Button, TopToolbar, Pagination, RefreshButton, ExportButton, Filter, TextInput, GET_ONE } from 'react-admin';
import { Scrollbars } from 'react-custom-scrollbars';
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from '../common/common'
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import Spinner from '../../src/spinner';
import myDataProvider from '../myRestProvider';
import moment from 'moment';
import Modal from 'react-responsive-modal';
import Swal from 'sweetalert2';
import GetAppIcon from '@mui/icons-material/GetApp';

const selectInputStyle = {
  width: 220,
};

const SalesOfficersFilter = (props) => (
  <Filter {...props}>
    <TextInput source="sales_officer_username" label="Sales Officers Name" />
    <TextInput source="sales_officer_email" label="Sales Officers Email" />
    <TextInput source="sales_officer_phone" label="Sales Officers phone" />
    <SelectInput style={selectInputStyle} source="sales_officer_status" label="Sales Officers Status" choices={[
      { id: true, name: 'True' },
      { id: false, name: 'False' },
    ]} />
    <TextInput source="business_name" label="Sold To Name" />
    <TextInput source="business_sap_code" 
    // label="Sold To Id"
     />
  </Filter>
);

const StatusField = ({ record = {}, source }) => (
  <span>{record[source] === null ? '-' : (record[source] ? 'True' : 'False')}</span>
)
const UserName = ({ record }) => {
  return <span>{record && record.sales_officer_username ? `${record.sales_officer_username}` : '-'}</span>;
};


// const TopToolbarStyle = {
//   zIndex: 2,
//   display: 'inline-block',
//   float: 'right',
// };

// const ListActions = ({ resource, basePath, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters }) => {
//   return (
//     <TopToolbar>
//       {filters && cloneElement(filters, {
//         resource,
//         showFilter,
//         displayedFilters,
//         filterValues,
//         context: 'button',
//       })}
//       <RefreshButton />
//       <CreateButton basePath={basePath} />
//       <ExportButton
//         disabled={total === 0}
//         resource={resource + '_csv'}
//         sort={currentSort}
//         filter={{ ...filterValues, ...permanentFilter }}
//         exporter={exporter}
//         maxResults={maxResults}
//       />
//     </TopToolbar>
//   )
// }

// const ListActions = (props) => {
//   const [modalShow, setModalShow] = React.useState(false);
//   const [modalMsg, setModalMsg] = React.useState('')
//   const { resource, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters } = props;
//   const csvResource = resource + '_csv'
//   const options = CommonHeaderOption();
//   const apiUrl = RUN_TIME_API_ENDPOINT;

//   const callExport = (e) => {
//     e.preventDefault();
//     console.log('...', window.location.href, `${apiUrl}/${resource}_csv`)
//     options.method = 'GET';
//     fetch(`${apiUrl}/${resource}_csv?filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D`, options)
//       .then(res => {
//           return res.json();
//       }).then(jsonD => {
//         console.log('jsonD VVVVVVx===>', jsonD.data);
//         const msg = jsonD.data? jsonD.data[0].message : '';
//         setModalShow(true);
//         setModalMsg(msg);
//       });
//   }
//   const exporterModal = () => {
//     return ''
//   }

//   const onClose = () => {
//     setModalShow(false)
//   }
//   return (
//     <React.Fragment>
//     <TopToolbar>
//       {filters && cloneElement(filters, {
//         resource,
//         showFilter,
//         displayedFilters,
//         filterValues,
//         context: 'button',
//       })}
//       <RefreshButton />
//       <ExportButton
//         onClick={(e) => callExport(e)}
//         disabled={total === 0}
//         resource={csvResource}
//         sort={currentSort}
//         filter={{ ...filterValues, ...permanentFilter }}
//         exporter={exporterModal}
//         maxResults={maxResults}
//         />
//     </TopToolbar>
//     {
//           modalShow &&
//           <Modal open={modalShow} onClose={onClose} center> 
//             <h3>{modalMsg}</h3>
//           </Modal>
//     }
//     </React.Fragment>
//   )
// }

class ListActions extends Component {
  constructor(props) {

    super(props);
    this.state = {
      modalShow: false,
      modalMsg: '',
      customFilterUrl: 'filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D',
    }
  }

  callExport = (e) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    e.preventDefault();
    console.log('...', window.location.href, `${apiUrl}/${this.props.resource}_csv`)
    options.method = 'GET';
    let _url = window.location.href.split('?');
    if (_url.length > 1 && _url[1] !== '') {
      console.log('params found');
      this.setState({ customFilterUrl: _url[1] }, () => {
        fetch(`${apiUrl}/${this.props.resource}_csv?${this.state.customFilterUrl}`, options)
          .then(res => {
            return res.json();
          }).then(jsonD => {
            console.log('json= inside callback', jsonD.data);
            const msg = jsonD.data ? jsonD.data[0].message : '';
            Swal.fire({
              html: msg,
              icon: 'success',
            })
            // this.setState({ modalShow: true});
            // this.setState({ modalMsg: msg});
          });
      })
    } else {
      this.setState({ customFilterUrl: 'filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D' }, () => {
        fetch(`${apiUrl}/${this.props.resource}_csv?${this.state.customFilterUrl}`, options)
          .then(res => {
            return res.json();
          }).then(jsonD => {
            console.log('json= inside callback', jsonD.data);
            const msg = jsonD.data ? jsonD.data[0].message : '';
            Swal.fire({
              html: msg,
              icon: 'success',
            })
            // this.setState({ modalShow: true});
            // this.setState({ modalMsg: msg});
          });
      })
    }
  }
  exporterModal = () => {
    return ''
  }

  onClose = () => {
    this.setState({ modalShow: false })
  }
  render() {
    const { resource, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters, basePath } = this.props;
    const csvResource = resource + '_csv'
    return (
      <React.Fragment>
        <TopToolbar>
          {filters && cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
          })}
          <CreateButton basePath={basePath} />
          <RefreshButton />
          {/* <ExportButton
        onClick={(e) => this.callExport(e)}
        disabled={total === 0}
        resource={csvResource}
        sort={currentSort}
        filter={{ ...filterValues, ...permanentFilter }}
        exporter={this.exporterModal}
        maxResults={maxResults}
        /> */}
          <div>
            <button className="export-button"
              onClick={(e) => this.callExport(e)}
              disabled={total === 0}
              sort={currentSort}
              filter={{ ...filterValues, ...permanentFilter }}
            >
              {<GetAppIcon />}
              <span>Export</span>
            </button>
          </div>
        </TopToolbar>
        {
          this.state.modalShow &&
          <Modal open={this.state.modalShow} onClose={this.onClose} center>
            <h3>{this.state.modalMsg}</h3>
          </Modal>
        }
      </React.Fragment>
    )
  }
}



const SalesOfficersList = (props, permissions) => {

  // const [moodalShow, setMoodalShow] = useState(false);
  // const [modalMsg, setModalMsg] = useState('');

  const exporter = (data) => {
    // const msg = data[0].message;
    // setModalMsg(true);
    // setModalMsg(msg);
    return ''
  }

  // const onClose = () => {
  //   setMoodalShow(false);
  // }

  // render() {
  // const { state, props, permissions } = this;
  return (
    <React.Fragment>
      <Scrollbars className="scroll-container">
        <List {...props} exporter={exporter} sort={{ field: 'sales_officer_created_at', order: 'DESC' }} filters={<SalesOfficersFilter />} title="Sales Officers" bulkActionButtons={false} actions={<ListActions permissions={props} />} >
          <Datagrid>
            <UserName label="Sales Officers Name" />
            <TextField source="sales_officer_email" label="Sales Officers Email" />
            <TextField source="sales_officer_phone" label="Sales Officers phone" />
            <TextField source="business_sap_code" 
            // label="Sold To ID" 
            />
            <TextField source="business_name" label="Sold To Name" />
            <StatusField source="sales_officer_status" label="Login Enabled" />
            <DateField source="sales_officer_created_at" label="Sales Officers created_at" showTime={true} />
            <EditButton />
            <DeleteButton />
          </Datagrid>
        </List>
      </Scrollbars>
      {/* {
          moodalShow &&
          <Modal open={moodalShow} onClose={onClose} center>
            <h3>{modalMsg}</h3>
          </Modal>
        } */}
    </React.Fragment>
  )
  // }
}

export default SalesOfficersList;